import React, { ReactNode } from 'react';
import { StyledLayout } from './styled';
import { useScrollState } from '../../../hooks/useScrollState';

interface MainLayoutProps {
  isWebView?: boolean;
  children?: ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({
  isWebView,
  children
}) => {
  const { isScroll } = useScrollState();
  const isWebViewScroll = Boolean(isWebView && isScroll);

  return (
    <StyledLayout
      className={isWebViewScroll ? 'scrolling' : undefined}
      $isWebViewScroll={isWebViewScroll}
    >
      {children}
    </StyledLayout>
  );
};
